var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',_vm._b({attrs:{"value":_vm.context.model ? _vm.context.model : null,"options":_vm.context.options},on:{"input":_vm.context.attributes.input,"select":_vm.context.attributes.select}},'treeselect',_vm.context.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }